import React, { useCallback, useEffect, useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Button,
    TextField,
    Paper,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    IconButton,
    Box,
    Typography,
} from '@material-ui/core';
import { Edit, Remove } from '@material-ui/icons';
import AddUserForm from './AddUserForm';
import Layout from './Layout';
import Pagination from '@mui/material/Pagination';
import { CircularProgress } from '@material-ui/core';


export const UserManagement = () => {

    const [responseData, setResponseData] = useState(null);
    const [selectedFilter, setSelectedFilter] = useState('');
    const [filterValue, setFilterValue] = useState('');
    const [updatedRows, setUpdatedRows] = useState([]);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);


    const baseUrl =
        window.farmers === 'dev'
            ? 'https://dev.phyfarm.com/'
            : 'https://dev.phyfarm.com/';

    const onSubmit = useCallback(() => {

        setLoading(true);

        if ((selectedFilter && filterValue) || (selectedFilter === '' && filterValue === '')) {
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    filter: {
                        key: selectedFilter,
                        value: filterValue,
                    },
                    pagination: {
                        current_page: currentPage,
                    },
                }),
            };

            fetch(baseUrl + 'api/mgmt/farmers/listFarmers', requestOptions)
                .then((response) => response.json())
                .then((data) => {
                    console.log(data);
                    setResponseData(data);
                    if (data.data.farmers === null) {
                        setCurrentPage(1)
                    }
                    setLoading(false);
                })
                .catch((error) => {
                    console.log(error);
                    alert('Something went wrong!');
                    setLoading(false);
                });
        }
    }, [selectedFilter, filterValue, currentPage]);

    useEffect(() => {
        onSubmit();
    }, [currentPage, filterValue, selectedFilter]);

    const handlePageChange = (event, page) => {
        setCurrentPage(page);
        console.log(currentPage)
        onSubmit()
    };


    const handleOpenPopup = () => {
        setIsPopupOpen(true);
    };

    const handleSubmitPopup = (formData) => {
        const newUser = {
            id: formData.id,
            name: formData.name,
            city: formData.city,
            state: formData.state,
            phone: formData.phone,
            email: formData.email,
            farmSize: formData.farmSize,
            leadStatus: formData.leadStatus,
        };

        const requestOptions = {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(newUser),
        };

        fetch(baseUrl + 'api/mgmt/farmers/createFarmer', requestOptions)
            .then((response) => response.json())
            .then((data) => {
                setIsPopupOpen(false);
                onSubmit();
            })
            .catch((error) => {
                console.log(error);
                alert('Something went wrong!');
            });
    };


    const handleUpdate = (index) => {
        setUpdatedRows([...updatedRows, index]);
    };

    const handleFieldChange = (value, field, index) => {
        const updatedData = [...responseData.data.farmers];
        updatedData[index][field] = value;
        setResponseData({ ...responseData, data: { farmers: updatedData } });
    };

    const handleSave = (index) => {
        const updatedData = responseData.data.farmers[index];
        const transformedData = {
            id: updatedData.ObjectID,
            name: updatedData.Name,
            city: updatedData.City,
            state: updatedData.State,
            phone: updatedData.Phone,
            email: updatedData.Email,
            farmSize: updatedData.FarmSize,
            leadStatus: updatedData.LeadStatus,
        }

        const requestOptions = {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(transformedData),
        };

        fetch(baseUrl + 'api/mgmt/farmers/update', requestOptions)
            .then((response) => response.json())
            .then((data) => {
                console.log(data);
                setUpdatedRows(updatedRows.filter((rowIndex) => rowIndex !== index));
            })
            .catch((error) => {
                console.log(error);
                alert('Something went wrong!');
            });
    };

    const handleCancel = (index) => {
        setUpdatedRows(updatedRows.filter((rowIndex) => rowIndex !== index));
        onSubmit();
    };

    const handleDelete = (index) => {
        const farmerToDelete = responseData.data.farmers[index];
        const updatedFarmers = [...responseData.data.farmers];
        updatedFarmers.splice(index, 1);
        const updatedResponseData = { ...responseData, data: { farmers: updatedFarmers } };
        setResponseData(updatedResponseData);

        const requestOptions = {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ id: farmerToDelete.ObjectID }),
        };

        fetch(baseUrl + 'api/mgmt/farmers/deleteFarmer', requestOptions)
            .then((response) => response.json())
            .then((data) => {
                console.log(data);
            })
            .catch((error) => console.log(error));
    };


    return (
        <Layout>

            <div className="App">



                <Typography variant="h5" style={{ marginTop: 100 }}>User Management</Typography>

                <div style={{ display: 'flex', justifyContent: 'center', margin: 70 }}>

                    <FormControl style={{ marginRight: '16px' }}>
                        <InputLabel id="filter-label" style={{ marginLeft: 10, marginBottom: 10 }}>Filter By</InputLabel>
                        <Select
                            labelId="filter-label"
                            id="filter-select"
                            value={selectedFilter}
                            variant='outlined'
                            onChange={(e) => setSelectedFilter(e.target.value)}
                            style={{ width: '200px', marginRight: '16px' }}
                        >
                            <MenuItem value="name">Name</MenuItem>
                            <MenuItem value="city">City</MenuItem>
                            <MenuItem value="state">State</MenuItem>
                            <MenuItem value="email">Email</MenuItem>
                            <MenuItem value="phone">Phone</MenuItem>
                            <MenuItem value="farmSize">Farm Size</MenuItem>
                            <MenuItem value="leadStatus">Lead Status</MenuItem>
                        </Select>
                    </FormControl>
                    <TextField
                        id="filter-value"
                        label="Filter Value"
                        value={filterValue}
                        variant='outlined'
                        onChange={(e) => setFilterValue(e.target.value)}
                        style={{ marginRight: '16px' }}
                    />
                    <Button
                        variant="contained"
                        onClick={() => {
                            setSelectedFilter('');
                            setFilterValue('');
                            onSubmit();
                        }}
                        style={{ margin: 10, backgroundColor: '#3074d4', color: 'white', marginRight: '16px' }}
                    >
                        Clear
                    </Button>
                </div>

                <Box>
                    <Button
                        variant="contained"
                        startIcon={<AddIcon />}
                        color='primary'
                        onClick={handleOpenPopup}
                        style={{ marginTop: '-100px', marginRight: "10px" }}
                    >
                        New User
                    </Button>
                </Box>

                {isPopupOpen && (
                    <AddUserForm
                        isOpen={isPopupOpen}
                        onClose={() => setIsPopupOpen(false)}
                        onSubmit={handleSubmitPopup}
                    />
                )}

                <Pagination
                    count={responseData == null ? 0 : Math.ceil(responseData.data.totalCount / responseData.data.perPage)}
                    page={currentPage}
                    onChange={handlePageChange}
                    style={{ marginTop: '16px', display: 'flex', justifyContent: 'center' }}
                />

                {loading ? (
                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: 16 }}>
                        <CircularProgress />
                    </div>
                ) : (
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center" style={{ fontWeight: 'bold' }}>
                                        Name
                                    </TableCell>
                                    <TableCell align="center" style={{ fontWeight: 'bold' }}>
                                        City
                                    </TableCell>
                                    <TableCell align="center" style={{ fontWeight: 'bold' }}>
                                        State
                                    </TableCell>
                                    <TableCell align="center" style={{ fontWeight: 'bold' }}>
                                        Email
                                    </TableCell>
                                    <TableCell align="center" style={{ fontWeight: 'bold' }}>
                                        Phone
                                    </TableCell>
                                    <TableCell align="center" style={{ fontWeight: 'bold' }}>
                                        Farm Size
                                    </TableCell>
                                    <TableCell align="center" style={{ fontWeight: 'bold' }}>
                                        Lead Status
                                    </TableCell>
                                    <TableCell align="center" style={{ fontWeight: 'bold' }}>
                                        Actions
                                    </TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>

                                {responseData &&
                                    responseData.data &&
                                    Array.isArray(responseData.data.farmers) ? (
                                    responseData.data.farmers.map((farmer, index) => (
                                        <TableRow
                                            key={index}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell align="center">
                                                {updatedRows.includes(index) ? (
                                                    <TextField
                                                        value={farmer.Name}
                                                        onChange={(e) =>
                                                            handleFieldChange(e.target.value, 'Name', index)
                                                        }
                                                    />
                                                ) : (
                                                    farmer.Name
                                                )}
                                            </TableCell>
                                            <TableCell align="center">
                                                {updatedRows.includes(index) ? (
                                                    <TextField
                                                        value={farmer.City}
                                                        onChange={(e) =>
                                                            handleFieldChange(e.target.value, 'City', index)
                                                        }
                                                    />
                                                ) : (
                                                    farmer.City
                                                )}
                                            </TableCell>
                                            <TableCell align="center">
                                                {updatedRows.includes(index) ? (
                                                    <TextField
                                                        value={farmer.State}
                                                        onChange={(e) =>
                                                            handleFieldChange(e.target.value, 'State', index)
                                                        }
                                                    />
                                                ) : (
                                                    farmer.State
                                                )}
                                            </TableCell>
                                            <TableCell align="center">
                                                {updatedRows.includes(index) ? (
                                                    <TextField
                                                        value={farmer.Email}
                                                        onChange={(e) =>
                                                            handleFieldChange(e.target.value, 'Email', index)
                                                        }
                                                    />
                                                ) : (
                                                    farmer.Email
                                                )}
                                            </TableCell>
                                            <TableCell align="center">
                                                {updatedRows.includes(index) ? (
                                                    <TextField
                                                        value={farmer.Phone}
                                                        onChange={(e) =>
                                                            handleFieldChange(e.target.value, 'Phone', index)
                                                        }
                                                    />
                                                ) : (
                                                    farmer.Phone
                                                )}
                                            </TableCell>
                                            <TableCell align="center">
                                                {updatedRows.includes(index) ? (
                                                    <TextField
                                                        value={farmer.FarmSize}
                                                        onChange={(e) =>
                                                            handleFieldChange(e.target.value, 'FarmSize', index)
                                                        }
                                                    />
                                                ) : (
                                                    farmer.FarmSize
                                                )}
                                            </TableCell>
                                            <TableCell align="center">
                                                {updatedRows.includes(index) ? (
                                                    <TextField
                                                        value={farmer.LeadStatus}
                                                        onChange={(e) =>
                                                            handleFieldChange(e.target.value, 'LeadStatus', index)
                                                        }
                                                    />
                                                ) : (
                                                    farmer.LeadStatus
                                                )}
                                            </TableCell>
                                            <TableCell align="center">
                                                {updatedRows.includes(index) ? (
                                                    <div>
                                                        <Button
                                                            variant="contained"
                                                            onClick={() => handleSave(index)}
                                                            style={{
                                                                backgroundColor: '#4caf50',
                                                                color: 'white',
                                                                marginRight: '8px',
                                                                margin: "8px"
                                                            }}
                                                        >
                                                            Save
                                                        </Button>
                                                        <Button
                                                            variant="contained"
                                                            onClick={() => handleCancel(index)}
                                                            style={{ backgroundColor: '#f44336', color: 'white' }}
                                                        >
                                                            Cancel
                                                        </Button>
                                                    </div>
                                                ) : (
                                                    <div>
                                                        <IconButton
                                                            onClick={() => handleUpdate(index)}
                                                            style={{ marginRight: '8px', color: "green" }}
                                                        >
                                                            <Edit />
                                                        </IconButton>
                                                        <IconButton
                                                            onClick={() => handleDelete(index)}
                                                            style={{ color: "red" }}
                                                        >
                                                            <Remove />
                                                        </IconButton>
                                                    </div>
                                                )}
                                            </TableCell>

                                        </TableRow>
                                    ))
                                ) : responseData && !responseData.data ? (
                                    <TableRow>
                                        <TableCell colSpan={8} align="center">
                                            No data available
                                        </TableCell>
                                    </TableRow>
                                ) : null
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </div>
        </Layout>
    );
};
